import { create } from 'zustand';

export interface UserStoreState {
  id: number | string;
  fio: string;
  first_name: string;
  second_name: string;
  phone: string;
  type: string;
  created_at: string;
  updated_at: string;
}

interface UserPhoneStoreActions {
  setPhone: (phone: string) => void;
  setUser: (user: UserStoreState) => void;
}

interface UserStore {
  state: UserStoreState;
  actions: UserPhoneStoreActions;
}

export const useUserStore = create<UserStore>((set) => ({
  state: {
    phone: '',
    id: '',
    fio: '',
    first_name: '',
    second_name: '',
    type: '',
    created_at: '',
    updated_at: '',
  },
  actions: {
    setPhone: (phone) =>
      set((state) => {
        return { state: { ...state.state, phone } };
      }),
    setUser: (user) => set({ state: user }),
  },
}));
